// extracted by mini-css-extract-plugin
export default {"menuControls":"c-a_eK","menuControls_styleDefault":"c-a_eL","menuControls_styleRed":"c-a_eM"};